import { prefixer, createApiConsts } from '../../../Helpers/constants'

const createPrefixedConst = prefixer('MEDIA_PLAYER')
const createPrefixedApiConsts = <ApiName extends string>(apiName: ApiName) => createApiConsts(createPrefixedConst(apiName))

export const RESET_MEDIA_PLAYER = 'RESET_MEDIA_PLAYER'

export const GET_CONTACT_REQUESTED = 'GET_CONTACT_REQUESTED'
export const GET_CONTACT_SUCCESS = 'GET_CONTACT_SUCCESS'
export const GET_CONTACT_FAILURE = 'GET_CONTACT_FAILURE'

export const REFRESH_CONTACT_REQUESTED = 'REFRESH_CONTACT_REQUESTED'
export const REFRESH_CONTACT_SUCCESS = 'REFRESH_CONTACT_SUCCESS'
export const REFRESH_CONTACT_FAILURE = 'REFRESH_CONTACT_FAILURE'

export const GET_STORAGEFILE_REQUESTED = 'GET_STORAGEFILE_REQUESTED'
export const GET_STORAGEFILE_SUCCESS = 'GET_STORAGEFILE_SUCCESS'
export const GET_STORAGEFILE_FAILURE = 'GET_STORAGEFILE_FAILURE'

export const RESTORE_STORAGEFILES_REQUESTED = 'RESTORE_STORAGEFILES_REQUESTED'
export const RESTORE_STORAGEFILES_SUCCESS = 'RESTORE_STORAGEFILES_SUCCESS'
export const RESTORE_STORAGEFILES_FAILURE = 'RESTORE_STORAGEFILES_FAILURE'

export const ROLE_EVALUATOR = 'EVALUATOR'
export const ROLE_ANALYST = 'ANALYST'
export const ROLE_ALL = 'ALL'

export const GET_ROLE = createPrefixedApiConsts('GET_ROLE')
export const SAVE_ROLE = createPrefixedApiConsts('SAVE_ROLE')

export const UPDATE_MEDIA_PLAYER_CONTACT_REQUESTED = 'UPDATE_MEDIA_PLAYER_CONTACT_REQUESTED'
export const UPDATE_MEDIA_PLAYER_CONTACT_SUCCESS = 'UPDATE_MEDIA_PLAYER_CONTACT_SUCCESS'
export const UPDATE_MEDIA_PLAYER_CONTACT_FAILURE = 'UPDATE_MEDIA_PLAYER_CONTACT_FAILURE'

export const UPDATE_REVIEW_GOAL_REQUESTED = 'UPDATE_REVIEW_GOAL_REQUESTED'
export const UPDATE_REVIEW_GOAL_SUCCESS = 'UPDATE_REVIEW_GOAL_SUCCESS'
export const UPDATE_REVIEW_GOAL_FAILURE = 'UPDATE_REVIEW_GOAL_FAILURE'

export const SAVE_ARCHIVE_AUDIT_SUCCESS = 'SAVE_ARCHIVE_AUDIT_SUCCESS'
export const SAVE_ARCHIVE_AUDIT_FAILURE = 'SAVE_ARCHIVE_AUDIT_FAILURE'
export const SAVE_AUDIO_PLAYED_AUDIT_SUCCESS = 'SAVE_AUDIO_PLAYED_AUDIT_SUCCESS'
export const SAVE_AUDIO_PLAYED_AUDIT_FAILURE = 'SAVE_AUDIO_PLAYED_AUDIT_FAILURE'
export const SAVE_TEXT_VIEWED_AUDIT_SUCCESS = 'SAVE_TEXT_VIEWED_AUDIT_SUCCESS'
export const SAVE_TEXT_VIEWED_AUDIT_FAILURE = 'SAVE_TEXT_VIEWED_AUDIT_FAILURE'

export const UPDATE_CONTACT_AFTER_EVALUATION_SAVE = 'UPDATE_CONTACT_AFTER_EVALUATION_SAVE'
export const UPDATE_CONTACT_AFTER_EVALUATION_RESET = 'UPDATE_CONTACT_AFTER_EVALUATION_RESET'

export const GET_TENANT_LICENSED_FEATURES_REQUESTED = 'GET_TENANT_LICENSED_FEATURES_REQUESTED'
export const GET_TENANT_LICENSED_FEATURES_SUCCESS = 'GET_TENANT_LICENSED_FEATURES_SUCCESS'
export const GET_TENANT_LICENSED_FEATURES_FAILURE = 'GET_TENANT_LICENSED_FEATURES_FAILURE'

export const CONTACT_TYPE = {
  CALL: 'CALL',
  NON_CALL: 'NON_CALL',
  EMAIL: 'EMAIL',
  TEXT: 'TEXT',
  SCREEN_ONLY: 'SCREEN_ONLY',
  CHAT: 'CHAT',
  SMS: 'SMS',
} as const

export const SCOPE_TYPE = {
  ROOT: 'root',
  CCR: 'ccr',
} as const
